export default __webpack_public_path__ + "static/media/quadrilateral.fc16c360.png";